import { InjectionToken } from '@angular/core';
import { FitterNameDisplayContext } from '../models';

export const FITTER_NAME_DISPLAY_CONTEXT =
  new InjectionToken<FitterNameDisplayContext>('fitter-name-display-context');
